// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.link-ticket-csv {
  position: relative;
  display: inline-block;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 6px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin-top: 8px;
  z-index: 9999;
  min-width: 200px;
  display: none;
}
.dropdown-menu li {
  padding: 10px 16px;
  cursor: pointer;
  font-size: 14px;
  color: #333;
}
.dropdown-menu li:hover {
  background-color: #f2f2f2;
}

.dropdown-menu.open {
  display: block;
}

.csv-info-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  overflow-y: auto;
}

.csv-info-modal {
  background: #fff;
  padding: 24px 32px;
  border-radius: 12px;
  max-width: 550px;
  width: 90%;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.25);
  font-family: Arial, sans-serif;
  color: #222;
  position: relative;
  text-align: center;
}
.csv-info-modal h3 {
  margin-top: 0;
  font-size: 22px;
  font-weight: 700;
  margin-bottom: 12px;
}
.csv-info-modal p {
  font-size: 14px;
  line-height: 1.4;
  margin-bottom: 12px;
}
.csv-info-modal p strong {
  font-weight: 600;
}
.csv-info-modal ul {
  list-style: disc;
  padding-left: 20px;
  margin-bottom: 16px;
  text-align: left;
}
.csv-info-modal ul li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  margin-bottom: 8px;
}
.csv-info-modal ul li:last-child {
  margin-bottom: 0;
}
.csv-info-modal ul li span {
  flex-grow: 1;
}
.csv-info-modal ul li .copy-btn {
  margin-left: 12px;
  padding: 4px 10px;
  font-size: 12px;
  font-weight: 600;
  background-color: #1d0f40;
  color: #fff;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}
.csv-info-modal ul li .copy-btn:hover {
  background-color: #271456;
}
.csv-info-modal ul li .copy-btn.copied {
  background-color: #28a745;
  cursor: default;
}
.csv-info-modal .copy-full-list-btn {
  display: inline-block;
  background-color: #1d0f40;
  color: #fff;
  font-weight: 600;
  padding: 8px 14px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.3s ease;
}
.csv-info-modal .copy-full-list-btn:hover {
  background-color: #271456;
}
.csv-info-modal .copy-full-list-btn.copied {
  background-color: #28a745;
  cursor: default;
}
.csv-info-modal .close-info-btn {
  background-color: #1d0f40;
  color: #fff;
  padding: 10px 18px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 700;
  width: 100%;
  transition: background-color 0.3s ease;
}
.csv-info-modal .close-info-btn:hover {
  background-color: #271456;
}

.close-cross-btn {
  position: absolute;
  top: 12px;
  right: 12px;
  background: transparent;
  border: none;
  font-size: 28px;
  font-weight: 700;
  color: #888;
  cursor: pointer;
  line-height: 1;
  transition: color 0.3s ease;
}
.close-cross-btn:hover {
  color: #1d0f40;
}

.copy-inline-row-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 16px;
}

.copy-inline-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.copy-label {
  display: inline-block;
  width: 140px;
  text-align: right;
  font-weight: 600;
  line-height: 1;
}

.toggle-list-btn {
  background-color: transparent;
  border: 1px solid #1d0f40;
  color: #1d0f40;
  padding: 6px 12px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  transition: all 0.3s ease;
}
.toggle-list-btn:hover {
  background-color: #1d0f40;
  color: #fff;
}

.copy-section-wrapper {
  margin-bottom: 24px;
}

.copy-inline-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
}

.copy-label {
  font-weight: 700;
  font-size: 18px;
  flex-shrink: 0;
}

.toggle-list-btn {
  background-color: transparent;
  color: #1d0f40;
  border: 2px solid #1d0f40;
  font-weight: 600;
  padding: 6px 12px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.3s ease, color 0.3s ease;
}

.toggle-list-btn:hover {
  background-color: #1d0f40;
  color: white;
}

.copy-list-items {
  margin-top: 8px;
  padding-left: 20px;
  list-style-type: disc;
  font-size: 14px;
  color: #222;
}`, "",{"version":3,"sources":["webpack://./src/components/link-ticket-csv/link-ticket-csv.styles.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,qBAAA;AACJ;;AAEE;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,uBAAA;EACA,sBAAA;EACA,kBAAA;EACA,wCAAA;EACA,eAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;AACJ;AACI;EACE,kBAAA;EACA,eAAA;EACA,eAAA;EACA,WAAA;AACN;AACM;EACE,yBAAA;AACR;;AAIE;EACE,cAAA;AADJ;;AAIE;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,gBAAA;AADJ;;AAIE;EACE,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,UAAA;EACA,0CAAA;EACA,8BAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;AADJ;AAGI;EACE,aAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AADN;AAII;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;AAFN;AAIM;EACE,gBAAA;AAFR;AAKA;EACI,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AAHJ;AAKI;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,kBAAA;AAHR;AAKQ;EACA,gBAAA;AAHR;AAMQ;EACA,YAAA;AAJR;AAOQ;EACA,iBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,sCAAA;AALR;AAOQ;EACI,yBAAA;AALZ;AAQQ;EACI,yBAAA;EACA,eAAA;AANZ;AAYI;EACE,qBAAA;EACA,yBAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,sCAAA;AAVN;AAYM;EACE,yBAAA;AAVR;AAaM;EACE,yBAAA;EACA,eAAA;AAXR;AAeI;EACE,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,sCAAA;AAbN;AAeM;EACE,yBAAA;AAbR;;AAkBE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;EACA,2BAAA;AAfJ;AAiBI;EACE,cAAA;AAfN;;AAmBE;EACE,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAhBJ;;AAmBE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAhBJ;;AAmBE;EACE,qBAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AAhBJ;;AAmBE;EACE,6BAAA;EACA,yBAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;AAhBJ;AAkBI;EACE,yBAAA;EACA,WAAA;AAhBN;;AAoBE;EACE,mBAAA;AAjBJ;;AAoBE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AAjBJ;;AAoBE;EACE,gBAAA;EACA,eAAA;EACA,cAAA;AAjBJ;;AAoBE;EACE,6BAAA;EACA,cAAA;EACA,yBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,uDAAA;AAjBJ;;AAoBE;EACE,yBAAA;EACA,YAAA;AAjBJ;;AAoBE;EACE,eAAA;EACA,kBAAA;EACA,qBAAA;EACA,eAAA;EACA,WAAA;AAjBJ","sourcesContent":[".link-ticket-csv {\n    position: relative;\n    display: inline-block;\n  }\n  \n  .dropdown-menu {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    background-color: white;\n    border: 1px solid #ccc;\n    border-radius: 6px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    margin-top: 8px;\n    z-index: 9999;\n    min-width: 200px;\n    display: none;\n  \n    li {\n      padding: 10px 16px;\n      cursor: pointer;\n      font-size: 14px;\n      color: #333;\n  \n      &:hover {\n        background-color: #f2f2f2;\n      }\n    }\n  }\n  \n  .dropdown-menu.open {\n    display: block;\n  }\n  \n  .csv-info-modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.5);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 2000;\n    overflow-y: auto;\n  }\n  \n  .csv-info-modal {\n    background: #fff;\n    padding: 24px 32px;\n    border-radius: 12px;\n    max-width: 550px;\n    width: 90%;\n    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.25);\n    font-family: Arial, sans-serif;\n    color: #222;\n    position: relative;\n    text-align: center;\n  \n    h3 {\n      margin-top: 0;\n      font-size: 22px;\n      font-weight: 700;\n      margin-bottom: 12px;\n    }\n  \n    p {\n      font-size: 14px;\n      line-height: 1.4;\n      margin-bottom: 12px;\n  \n      strong {\n        font-weight: 600;\n      }\n    }\nul {\n    list-style: disc;\n    padding-left: 20px;\n    margin-bottom: 16px;\n    text-align: left;\n\n    li {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        font-size: 14px;\n        margin-bottom: 8px;\n\n        &:last-child {\n        margin-bottom: 0;\n        }\n\n        span {\n        flex-grow: 1;\n        }\n\n        .copy-btn {\n        margin-left: 12px;\n        padding: 4px 10px;\n        font-size: 12px;\n        font-weight: 600;\n        background-color: #1d0f40;\n        color: #fff;\n        border: none;\n        border-radius: 6px;\n        cursor: pointer;\n        transition: background-color 0.3s ease;\n\n        &:hover {\n            background-color: #271456;\n        }\n\n        &.copied {\n            background-color: #28a745;\n            cursor: default;\n        }\n        }\n    }\n    }\n  \n    .copy-full-list-btn {\n      display: inline-block;\n      background-color: #1d0f40;\n      color: #fff;\n      font-weight: 600;\n      padding: 8px 14px;\n      border-radius: 8px;\n      border: none;\n      cursor: pointer;\n      font-size: 14px;\n      transition: background-color 0.3s ease;\n  \n      &:hover {\n        background-color: #271456;\n      }\n  \n      &.copied {\n        background-color: #28a745;\n        cursor: default;\n      }\n    }\n  \n    .close-info-btn {\n      background-color: #1d0f40;\n      color: #fff;\n      padding: 10px 18px;\n      border: none;\n      border-radius: 8px;\n      cursor: pointer;\n      font-size: 16px;\n      font-weight: 700;\n      width: 100%;\n      transition: background-color 0.3s ease;\n  \n      &:hover {\n        background-color: #271456;\n      }\n    }\n  }\n  \n  .close-cross-btn {\n    position: absolute;\n    top: 12px;\n    right: 12px;\n    background: transparent;\n    border: none;\n    font-size: 28px;\n    font-weight: 700;\n    color: #888;\n    cursor: pointer;\n    line-height: 1;\n    transition: color 0.3s ease;\n  \n    &:hover {\n      color: #1d0f40;\n    }\n  }\n  \n  .copy-inline-row-wrapper {\n    width: 100%;\n    display: flex;\n    justify-content: center; // centers the whole row on page\n    margin-bottom: 16px;\n  }\n  \n  .copy-inline-row {\n    display: flex;\n    align-items: center; // vertical alignment\n    gap: 12px;\n  }\n  \n  .copy-label {\n    display: inline-block;\n    width: 140px;\n    text-align: right;\n    font-weight: 600;\n    line-height: 1; // important to avoid extra height in label\n  }\n  \n  .toggle-list-btn {\n    background-color: transparent;\n    border: 1px solid #1d0f40;\n    color: #1d0f40;\n    padding: 6px 12px;\n    border-radius: 6px;\n    cursor: pointer;\n    font-size: 13px;\n    transition: all 0.3s ease;\n  \n    &:hover {\n      background-color: #1d0f40;\n      color: #fff;\n    }\n  }\n  \n  .copy-section-wrapper {\n    margin-bottom: 24px;\n  }\n  \n  .copy-inline-row {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    margin-bottom: 8px;\n  }\n  \n  .copy-label {\n    font-weight: 700;\n    font-size: 18px;\n    flex-shrink: 0;\n  }\n  \n  .toggle-list-btn {\n    background-color: transparent;\n    color: #1d0f40;\n    border: 2px solid #1d0f40;\n    font-weight: 600;\n    padding: 6px 12px;\n    border-radius: 6px;\n    cursor: pointer;\n    font-size: 14px;\n    transition: background-color 0.3s ease, color 0.3s ease;\n  }\n  \n  .toggle-list-btn:hover {\n    background-color: #1d0f40;\n    color: white;\n  }\n  \n  .copy-list-items {\n    margin-top: 8px;\n    padding-left: 20px;\n    list-style-type: disc;\n    font-size: 14px;\n    color: #222;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
